import { ActionButton, ActionButtonType } from "@octopusdeploy/design-system-components";
import { useAggregateAPIOperationStatus, useMutation } from "@octopusdeploy/octopus-react-client";
import type { ProjectTemplateResource, PublishProjectTemplateCommand, Repository } from "@octopusdeploy/octopus-server-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import PublishProjectTemplateWizardDialog from "~/areas/platformHub/projectTemplates/PublishProjectTemplateWizardDialog";
import { useDialogTrigger } from "~/components/Dialog/DialogTrigger";
import { PermissionCheck } from "~/components/PermissionCheck/index";
import { useProjectTemplateWizardDialog } from "./ProjectTemplateWizardDialogContext";
interface ProjectTemplatePublishButtonProps {
    projectTemplate: ProjectTemplateResource;
    onPublished?: () => void;
}
export default function ProjectTemplatePublishButton({ projectTemplate, onPublished }: ProjectTemplatePublishButtonProps) {
    const { isOpen, openDialog, closeAllDialogs } = useDialogTrigger();
    const { isInProgress, errors } = useAggregateAPIOperationStatus();
    const { publishedVersions, reloadPublishedVersions, refetchProjectTemplateStatus } = useProjectTemplateWizardDialog();
    const { execute: publishTemplate } = useMutation({
        name: "Publish project template",
        action: async (repo: Repository, params: {
            version: string;
            releaseNotes: string;
        }) => {
            const command: PublishProjectTemplateCommand = {
                ProjectTemplateSlug: projectTemplate.Slug,
                GitRef: projectTemplate.GitRef,
                Version: params.version,
                ReleaseNotes: params.releaseNotes,
            };
            return await repo.ProjectTemplates.publishVersion(command);
        },
        afterComplete: async () => {
            onPublished?.();
            await reloadPublishedVersions();
            refetchProjectTemplateStatus();
        },
    });
    return (<>
            <PermissionCheck permission={Permission.PlatformHubEdit}>
                <ActionButton label={"Publish"} type={ActionButtonType.Secondary} accessibleName={"Publish"} onClick={openDialog}/>
            </PermissionCheck>

            <PublishProjectTemplateWizardDialog open={isOpen} busy={isInProgress} errors={errors} template={projectTemplate} gitRef={projectTemplate.GitRef} publishedVersions={publishedVersions} hasUnsupportedSteps={false} onPublish={async ({ versionToPublish, releaseNotes }) => {
            await publishTemplate({ version: versionToPublish, releaseNotes });
            await reloadPublishedVersions();
            refetchProjectTemplateStatus();
            closeAllDialogs();
        }} closeDialog={closeAllDialogs}/>
        </>);
}
